import { z } from "zod";

const booleanSchema = (defaultValue: boolean) =>
  z
    .union([z.literal("true"), z.literal("false")])
    .default(defaultValue ? "true" : "false")
    .transform((value) => value === "true");

export const envSchema = z
  .object({
    VITE_JUICY_REGION: z.union([
      z.literal("https://score.juicyscore.net/static/js.js"),
      z.literal("https://score.juicyscore.com/static/js.js"),
    ]),
    VITE_JUICY_API_KEY: z.string(),

    VITE_API_URL: z.string(),
    VITE_AUTH_API_URL: z.string(),
    VITE_USE_PROXY: booleanSchema(false),
    VITE_ROOT_URL: z.string(),

    VITE_YM_ID: z.string().transform((value) => Number(value)),

    VITE_LIVETEX_ID: z.string().optional(),
    VITE_LIVETEX_ENABLED: booleanSchema(false),

    VITE_MFO_NAME_SHORT: z.string(),
    VITE_MFO_NAME_LONG: z.string(),
    VITE_MFO_THEME: z.literal("boomzaim"),

    VITE_VK_ANALYTICS_ID: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.VITE_LIVETEX_ENABLED && !data.VITE_LIVETEX_ID) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          "VITE_LIVETEX_ID is required when VITE_LIVETEX_ENABLED is true",
      });
    }
  });

export type EnvSchema = z.infer<typeof envSchema>;
